import { ComponentWithChildren } from 'modules/common/types';
import { createContext, useContext } from 'react';

import { ContextType } from './type';
import { useProviderValue } from './value';

const UpdateDonorsOwnerModalContext = createContext<ContextType | null>(null);

const UpdateDonorsOwnerModalProvider: ComponentWithChildren = ({
  children,
}) => {
  const providerValue = useProviderValue();

  return (
    <UpdateDonorsOwnerModalContext.Provider value={providerValue}>
      {children}
    </UpdateDonorsOwnerModalContext.Provider>
  );
};

export const useUpdateDonorsOwnerModalContext = () => {
  const context = useContext(UpdateDonorsOwnerModalContext);
  if (context === undefined) {
    throw new Error(
      'the useUpdateDonorsOwnerModalContext should be used within UpdateDonorsOwnerModalContextProvider!'
    );
  }

  return context;
};

export default UpdateDonorsOwnerModalProvider;
